import styled from "styled-components"

export const Wrapper = styled.div``

export const NextVacationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  margin-top: 10px;
`

export const NextVacationTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
`

export const NextVacationText = styled.div`
  font-size: 14px;
`

export const DateOnVacationContainer = styled.div`
  text-align: center;
  flex: 1;
  margin-top: 40px;
  margin-bottom: 40px;
  background-color: #fff;
  border-radius: 20px;
  padding: 20px;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.1;
  shadow-radius: 4px;
`

export const DateOnVacationTitle = styled.div`
  font-family: Poppins-SemiBold;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
`

export const DateOnVacationDescription = styled.div`
  font-family: Poppins-Regular;
  font-size: 14px;
  text-align: center;
`
